import { useTranslation } from 'react-i18next';
import ReturnTutorialStriemoKey from '../components/ReturnTutorialStriemoKey';

export default function ReturnTutorial() {
  const { t } = useTranslation();
    return (
      <div>
        <h2>{t('return guide page')}</h2>
        <ReturnTutorialStriemoKey />
      </div>
    )
  }